<script>
  import { onDestroy } from "svelte";

  // import {onMount} from 'svelte';
  import { tweened } from "svelte/motion";
  import { cubicOut } from "svelte/easing";
  import { activeStep, activeGroup } from "../../stores/mainStore";

  let className;
  let styleValues;

  export let steps;
  export let microsSteps;
  export let isMobile;

  export { className as class };
  export { styleValues as style };

  let activeGroup_value;
  let activeStep_value;

  let tmp_ActiveGroup = 0;
  // const progress = tweened(0, {
  //   duration: 700,
  //   easing: cubicOut
  // });

  function goToStep(index) {
    // if(index < activeStep_value)
    //   activeStep.set(index);
  }

  const unsubscribe = activeStep.subscribe(value => {
    activeStep_value = value;
    if (value == 0) {
      activeGroup.set(0);
    } else {
      if (microsSteps[value] == null) return;

      // if (microsSteps[value].group > microsSteps[tmp_ActiveGroup].group)
      //   activeGroup.increment();
      // else if (microsSteps[value].group < microsSteps[tmp_ActiveGroup].group)
      //   activeGroup.decrement();
      activeGroup.set(microsSteps[value].group);
    }

    tmp_ActiveGroup = value;
  });

  const unsubscribe_2 = activeGroup.subscribe(value => {
    activeGroup_value = value;
    // setTimeout(() => {
    //   progress.set((100 / steps.length) * (activeGroup_value + 1));
    // }, 10);
  });
  onDestroy(() => {
    unsubscribe();
    unsubscribe_2();
  });
</script>

<div class={className} style={styleValues}>
  <div
    class="w-full lg:h-12 flex-row text-center inline-block mx-auto container {isMobile ? 'is-mobile' : ''}" >
    {#each steps as step, i}
        <div class="step h-full bg-white float-left lg:float-none inline-block w-1/4 lg:w-auto" class:opacity-50={activeGroup_value < i} class:completed={activeGroup_value > i} class:last={i == steps.length -1 }>
          <button
            on:click|preventDefault={() => goToStep(i)}
            class="focus:outline-none focus:shadow-outline h-full mx-auto cursor-default">
            <div
              class="text-xs p-1 rounded-full inline-block transition
              duration-700 ease-in-out bg-gray-300"
              style="height:18px; width:18px;line-height:10px;"
              class:bg-main={activeGroup_value >= i}
              class:text-black={activeGroup_value < i}
              class:text-white={activeGroup_value >= i}>
              {i + 1}
            </div>
            <span class="text-sm block lg:inline">{isMobile ? step.nameShort : step.name}</span>
          </button>
        </div>
    {/each}
  </div>
</div>
<style>
.container:not(.is-mobile) .step:not(.last)::after{
  content: "";
  display:inline-block;
    width: 32px;
    height: 1px;
    background-color:#d2d6dc;
    color: #d2d6dc;
    margin: 0px 8px 0 4px;
    vertical-align: middle;
}

/* .container.is-mobile .step:not(.last)::after{
    width: 24px!important;
    margin: 0px 4px 0 2px!important;
} */


.step.completed::after{
    background-color:#000000;
    color: #000000;
}
</style>
